export default "__VITE_ASSET__359fcd5b__"